import React, { useEffect, useState, Fragment } from "react";
import $, { data } from "jquery";
import services from "../services";
import { trackPromise } from "react-promise-tracker";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { makeStyles } from "@material-ui/core/styles";
import tokenService from "../../../../Common/tokenDecoder";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { TextField } from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../../Common/table";
import MessageModal from "../../../../UI/Modal/MessageModal";
import { saveAs } from 'file-saver';
var JSZip = require("jszip");
var QRCode = require("qrcode.react");
var xlsx = require('json-as-xlsx');

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6, 9),
    borderRadius: 10,
    width: 600,
  },
  root: {
    "& > *": {
      margin: theme.spacing(5),
    },
  },
  remark: {
    width: 500,
  },
}));


export const EmployeeCardSuspendListing = (props) => {
  const { cardSuspendData, afterSuccessfulyChanged } = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({
    firstName: "",
    cardNumber: "",
    registrationNumber: "",
    remark: "",
  });
  const [cardSuspendFiltering, setCardSuspendFiltering] = useState([]);
  const handleClose = () => {
    setOpen(false);
  };
  const [cardSuspendDetails, setCardSuspendDetails] = useState({});
  const [cardInactivateDetails, setCardInactivateDetails] = useState({});
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });
  const [saveData, setSaveData] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const csvHeaders = [
    { label: "Registration Number", value: "registrationNumber" },
    { label: "Card Number", value: "cardNumber" },
    { label: "Name To Be Printed", value: "nameToBePrinted" },
    { label: "Date Of Birth", value: "dateOfBirth" }
  ];
  const selectAll = () => {
    setCheckAll(!checkAll);
  };

  useEffect(() => {
    trackPromise(setCardSuspendData());
  }, [cardSuspendData]);

  useEffect(() => {
    setCardSuspendDetails({
      ...cardSuspendDetails,
      remark: modalData.remark,
    });
  }, [modalData]);

  useEffect(() => {
    setCardInactivateDetails({
      ...cardInactivateDetails,
      remark: modalData.remark,
    });
  }, [modalData]);

  function getBase64String(dataURL) {
    var idx = dataURL.indexOf('base64,') + 'base64,'.length;
    return dataURL.substring(idx);
  }

  function handleDownload() {
    var zip = new JSZip();
    var img = zip.folder("images");

    if (saveData.length != 0) {
      saveData.map(item => {
        const canvas = document.getElementById(item.registrationNumber);
        const pngUrl = canvas.toDataURL();
        let baseString = getBase64String(pngUrl);

        const imagename = item.registrationNumber + "." + "jpeg"
        img.file(imagename, baseString, { base64: true });
      })

    }
    zip.generateAsync({ type: "blob" })
      .then(function (content) {
        // see FileSaver.js 
        saveAs(content, "Agrix-Employees.zip");
      });
  }

  function handleClick(data) {
    setModalData({
      ...modalData,
      name: data.firstName,
      cardNo: data.cardNumber,
      registerNo: data.registrationNumber,
      remark: data.remark,
    });
    setOpen(true);

    var token = tokenService.getUserDetailsFromToken();

    setCardSuspendDetails({
      ...cardSuspendDetails,
      cardID: data.cardID,
      createdBy: parseInt(token.id),
    });

    setCardInactivateDetails({
      ...cardInactivateDetails,
      cardID: data.cardID,
      createdBy: parseInt(token.id),
    });
  }
  function handleOneClick(data) {
    var token = tokenService.getUserDetailsFromToken();
    let cardData = {
      cardID: data.cardID,
      createdBy: parseInt(token.id),
      registrationNumber: data.registrationNumber,
      cardNumber: data.cardNumber,
      nameToBePrinted: data.nameToBePrinted,
      dateOfBirth: data.dateOfBirth.split('T')[0]
    };

    let dataRecords = [...saveData];

    var isEnable = dataRecords.find((p) => p.cardID == data.cardID);
    if (isEnable === undefined) {
      dataRecords.push(cardData);
    } else {
      var index = dataRecords.indexOf(isEnable);
      dataRecords.splice(index, 1);
    }

    setSaveData(dataRecords);
  }

  async function handleSuspend(e) {
    setOpen(false);
    e.preventDefault();
    const response = await services.updateSuspendCard(cardSuspendDetails);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  function handleClickAll(e) {
    var token = tokenService.getUserDetailsFromToken();

    var cardDataCopy = [...saveData];

    if (e.target.checked) {
      cardSuspendFiltering.forEach((x) => {
        let cardData = {
          cardID: x.cardID,
          createdBy: parseInt(token.id),
          registrationNumber: x.registrationNumber,
          cardNumber: x.cardNumber,
          nameToBePrinted: x.nameToBePrinted,
          dateOfBirth: x.dateOfBirth
        };

        var isEnable = cardDataCopy.find((p) => p.cardID == x.cardID);
        if (isEnable === undefined) {
          cardDataCopy.push(cardData);
        }
      });
      setSaveData(cardDataCopy);
    } else {
      setSaveData([]);
    }
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  async function handleInactivate(e) {
    setOpen(false);
    e.preventDefault();
    const response = await services.updateInactiveCard(cardInactivateDetails);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function handleChange(e) {
    setModalData({
      ...modalData,
      remark: e.target.value,
    });
  }

  async function setCardSuspendData() {
    await setCardSuspendFiltering(cardSuspendData);
  }

  function createFile(){
    var settings = {
      sheetName: 'Cards', // The name of the sheet
      fileName: 'EmployeeCardPrintDetails', // The name of the spreadsheet
      extraLength: 10, // A bigger number means that columns should be wider
      writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
    }
     
    var download = true // If true will download the xlsx file, otherwise will return a buffer
     
    xlsx(csvHeaders, saveData, settings, download) 
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <LoadingMaterialTable
        title=""
        columns={[
          {
            title: (
              <label>
                <Checkbox
                  color="primary"
                  onClick={(e) => handleClickAll(e)}
                  onChange={selectAll}
                  checked={cardSuspendFiltering.length != 0 && saveData.length == cardSuspendFiltering.length}
                ></Checkbox>
                Select All
              </label>
            ),
            sorting: false,
            field: "select",
            type: "boolean",
            render: (data) => (
              <Checkbox
                color="primary"
                onClick={() => handleOneClick(data)}
                checked={!(saveData.find((x) => x.cardID == data.cardID) == undefined)}
              ></Checkbox>
            ),
          },
          { title: "Card Number", field: "cardNumber" },
          { title: "Registration Number", field: "registrationNumber" },
          { title: "First Name ", field: "firstName" },
          { title: "Name to be Printed", field: "nameToBePrinted" },
          {
            title: "View",
            field: "view",
            render: (data) => (
              <VisibilityRoundedIcon
                onClick={() => handleClick(data)}
                style={{ cursor: "pointer" }}
              >
                {" "}
              </VisibilityRoundedIcon>
            ),
          },
        ]}
        data={cardSuspendFiltering}
      />
      <div className="card-footer">
        <input
          type="submit"
          className="btn btn-primary pull-right ml-2"
          value="Save As Images"
          onClick={handleDownload}
        />
        <input
          type="button"
          className="btn btn-primary pull-right ml-2"
          value="File Create"
          onClick={createFile}
        />
      </div>
      <div hidden={true}>
        {
          saveData.map((d) => (
            (
              <QRCode id={d.registrationNumber} value={d.cardNumber} size={100} bgColor="#FFFFFF" fgColor="#000000" />
            )))
        }
      </div>
      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.root}>
              <div className={classes.paper}>
                <div>
                  <TextField
                    fullWidth
                    label="Name"
                    type="text"
                    id="name"
                    name="name"
                    value={modalData.name}
                  />
                </div>
                <br />
                <div>
                  <TextField
                    fullWidth
                    label="Card Number"
                    type="text"
                    id="cardNo"
                    name="cardNo"
                    value={modalData.cardNo}
                  />
                </div>
                <br />
                <div>
                  <TextField
                    fullWidth
                    label="Registration Number"
                    type="text"
                    id="registerNo"
                    name="registerNo"
                    value={modalData.registerNo}
                  />
                </div>
                <br />
                <div>
                  <TextareaAutosize
                    aria-label="empty textarea"
                    rowsMin={5}
                    className={classes.remark}
                    placeholder="Remark"
                    id="remark"
                    name="remark"
                    value={modalData.remark}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <br />

                <input
                  type="submit"
                  className="btn btn-primary pull-left"
                  value="Suspend"
                  onClick={(e) => trackPromise(handleSuspend(e))}
                />
                <input
                  type="button"
                  className="btn btn-primary  "
                  value="Inactive"
                  onClick={(e) => trackPromise(handleInactivate(e))}
                />
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
};
